// extracted by mini-css-extract-plugin
export default {"categoryBody":"question-categories-module__categoryBody--MUvGt"};